class officeMap {
	constructor() {
		this.mapElt = $('#mapsvg')
		this.mapUrl = this.mapElt.attr('data-url')
		this.markerUrl = $('#marker_icon').val()
		this.mapColor = '#c3e0f2'
		this.mapBlueColor = '#2a4971'
		this.markersElts = $('#markers > input')
		this.searchElt = document.getElementById('js-search-map')
		this.closeBtn = $('#js-cross-close')
		this.previewOffficeeElt = $('#mapPreview')
		this.mapWrapper = $('.handsome-map__wrapper')
		this.mapFilter = $('.handsome-map__filter')
		this.timer = null

		this.init()
	}

	init() {
		if (this.mapElt.length) {
			// set initial map
			this.mapElt.mapSvg(this.getOptions())

			// Set initial autocomplete
			new Awesomplete(this.searchElt, {
				list: this.getMarkersName(),
				minChars: 1,
				replace: function(text) {
					this.input.value = text.label
				},
			})

			this.mapElt.hover(
				() => {
					this.timer = setInterval(() => {
						this.changeStroke()
					}, 500)
					this.changeStroke()
				},
				() => {
					clearInterval(this.timer)
				}
			)

			// Call openOffice on input select
			this.searchElt.addEventListener('awesomplete-selectcomplete', event => {
				if (event.text.value) this.openOffice(event.text.value)
			})

			// On input click
			this.searchElt.addEventListener('click', event => {
				this.searchElt.value = ''
				this.closeOffice()
			})

			// Or Close svg click
			this.closeBtn.on('click', () => {
				this.searchElt.value = ''
				this.closeOffice()
			})
		}
	}

	changeStroke() {
		const blue = this.mapBlueColor
		const light = this.mapColor
		const map = this.mapElt.find('svg')
		const style = map.attr('style')
		if (style === 'transform: scale(1);') {
			map.find('path').each(function() {
				$(this).css('stroke', light)
			})
		} else {
			map.find('path').each(function() {
				$(this).css('stroke', blue)
			})
		}
	}

	getMarkersName() {
		return this.getMarker().map(i => ({
			label: i.tooltip,
			value: i.id,
		}))
	}

	getMarker() {
		const thisClass = this
		let markers = []
		this.markersElts.each(function() {
			const el = $(this)
			markers.push({
				id: el.attr('data-id'),
				src: thisClass.markerUrl,
				geoCoords: [
					parseFloat(el.attr('data-lat')),
					parseFloat(el.attr('data-lng')),
				],
				tooltip: el.attr('data-title'),
				address: el.attr('data-address'),
				tel: el.attr('data-tel'),
				email: el.attr('data-email'),
				imgUrl: el.attr('data-img-url'),
				link: el.attr('data-link'),
			})
		})
		return markers
	}

	getOptions() {
		const isIE = /*@cc_on!@*/ !!document.documentMode
		const isEdge = !isIE && !!window.StyleMedia

		let thisClass = this
		let args = {
			source: this.mapUrl,
			height: 350,

			zoom: {
				on: true,
				buttons: {
					position: 'right',
				},
				limit: [0, 3],
			},
			scroll: {
				on: true,
			},

			colors: {
				base: this.mapColor,
				background: 'transparent',
				stroke: this.mapColor,
				selected: 0,
				hover: 0,
			},
			markers: this.getMarker(),
			onClick: function() {
				if (this.mapsvg_type === 'marker') {
					thisClass.openOffice(this.id)
				}
			},
		}

		if (!isIE && !isEdge) {
			// ALL Browsers
			args.responsive = true
			args.height = 350
		} else {
			// IE
			args.responsive = false
			args.height = 300
		}

		return args
	}

	/**
	 * @param id office ID
	 */
	openOffice(id) {
		// Get data from id
		let thisOffice = this.getMarker().filter(marker => marker.id === id)

		// Hide map markers
		this.mapElt.find('.mapsvg-layer-markers img').each(function() {
			if ($(this).attr('id') !== id) $(this).css('opacity', '0')
		})

		// Update DOM
		this.previewOffficeeElt.show('fast')
		this.previewOffficeeElt.find('#js-address').text(thisOffice[0].address)

		if (thisOffice[0].tel !== '') {
			$('.handsome-map__tel').css('display', 'flex')
			this.previewOffficeeElt
				.find('#js-tel')
				.show()
				.text(thisOffice[0].tel)
			this.previewOffficeeElt
				.find('#js-email')
				.show()
				.text(thisOffice[0].email)
			this.previewOffficeeElt
				.find('#js-link')
				.show()
				.attr('href', thisOffice[0].link)
		} else {
			$('.handsome-map__tel').css('display', 'none')
		}

		this.mapWrapper
			.css('background-image', 'url(' + thisOffice[0].imgUrl + ')')
			.removeClass('close')
	}

	closeOffice() {
		// Hide preview div
		this.previewOffficeeElt.hide('fast')

		// rm bg image
		this.mapWrapper.css('background-image', 'url()').addClass('close')

		// Display all markers
		this.mapElt.find('.mapsvg-layer-markers img').each(function() {
			$(this).css('opacity', '0.95')
		})
	}
}

export default officeMap
